/* BAKWAAS — minimal storefront behaviour. No framework, no build step. */
(function () {
  'use strict';

  var toast = document.getElementById('cart-toast');
  var toastTimer;

  function say(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 2600);
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add that item.'); });
      return res.json();
    });
  }

  /* ---- Mobile menu ---- */
  var menuButton = document.querySelector('[data-menu-toggle]');
  var drawer = document.getElementById('nav-drawer');
  if (menuButton && drawer) {
    menuButton.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', String(!open));
      menuButton.setAttribute('aria-expanded', String(!open));
      menuButton.textContent = open ? 'Menu' : 'Close';
    });
  }

  /* ---- Quick add from product cards ---- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add]');
    if (!button) return;
    var id = button.getAttribute('data-variant');
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';
    addToCart(id, 1)
      .then(function () { return refreshCount(); })
      .then(function () { say('Added to bag'); })
      .catch(function (error) { say(error.message); })
      .finally(function () { button.disabled = false; button.textContent = label; });
  });

  /* ---- Product page: option buttons drive the hidden variant select ---- */
  var form = document.querySelector('[data-pdp-form]');
  if (form) {
    var select = form.querySelector('[data-variant-select]');
    var addButton = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('.pdp__price');

    var chosen = [];
    form.querySelectorAll('.pdp__choice[aria-pressed="true"]').forEach(function (b) {
      chosen[Number(b.getAttribute('data-option-index'))] = b.getAttribute('data-value');
    });

    function syncVariant() {
      var match = null;
      Array.prototype.forEach.call(select.options, function (option) {
        var values = (option.getAttribute('data-options') || '').split('||');
        var hit = chosen.every(function (value, i) { return value === undefined || values[i] === value; });
        if (hit && !match) match = option;
      });

      if (!match) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        return;
      }
      select.value = match.value;
      if (priceEl) priceEl.textContent = match.getAttribute('data-price');
      addButton.disabled = match.disabled;
      addButton.textContent = match.disabled ? 'Sold out' : 'Add to bag';
    }

    form.addEventListener('click', function (event) {
      var choice = event.target.closest('.pdp__choice');
      if (!choice) return;
      var index = Number(choice.getAttribute('data-option-index'));
      choice.parentElement.querySelectorAll('.pdp__choice').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      choice.setAttribute('aria-pressed', 'true');
      chosen[index] = choice.getAttribute('data-value');
      syncVariant();
    });

    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter.name === 'checkout') return; // let Shopify handle Buy it now
      event.preventDefault();
      var label = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Adding';
      addToCart(select.value, 1)
        .then(function () { return refreshCount(); })
        .then(function () { say('Added to bag'); })
        .catch(function (error) { say(error.message); })
        .finally(function () { addButton.disabled = false; addButton.textContent = label; });
    });
  }
})();
